import * as React from "react";
import {
  Alert,
  Box,
  Button,
  Grid,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Divider,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ScheduleIcon from "@mui/icons-material/Schedule";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import Autocomplete from "@mui/material/Autocomplete";

import AuthService from "../auth/AuthService";
import Message from "../common/Message";
import config from "../config";
import qs from "query-string";
import { confirmationModal, appTheme, generateScheduleSummary, safeJsonParse } from "../utils";
import { LoaderSection, TimePickerSelect } from "../common";
import { daysOfWeek } from "../common/constants";

const Auth = new AuthService();

export default function AddMediaModal({ open, onClose, onSuccess, mediaId = 0 }) {
  const [id, setId] = React.useState(mediaId);
  const [screens, setScreens] = React.useState([]);
  const [file, setFile] = React.useState("");
  const [mediaType, setMediaType] = React.useState("");
  const [imageTimeout, setImageTimeout] = React.useState("");

  const [stores, setStores] = React.useState([]);
  const [selectedStores, setSelectedStores] = React.useState([]);
  const [selectedDays, setSelectedDays] = React.useState([]);
  const [screen, setScreen] = React.useState({ id: "", title: "" });
  const [screenError, setScreenError] = React.useState("");
  const [putURLs, setPutURLs] = React.useState([]);
  const [loadMessage, setLoadMessage] = React.useState("");
  const [type, setType] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [slectedStoreError, setSlectedStoreError] = React.useState("");
  const [schedule, setSchedule] = React.useState({
    start: null,
    end: null,
  });
  const [info, setInfo] = React.useState({
    type: "info",
    msg: "",
  });
  const [isDragging, setIsDragging] = React.useState(false);

  // Reset state when modal opens with a new id
  React.useEffect(() => {
    if (open) {
      setId(mediaId);
      setFile("");
      setMediaType("");
      setImageTimeout("");
      setPutURLs([]);
      setLoadMessage("");
      setType("");
      setInfo({ type: "info", msg: "" });
      setSchedule({ start: null, end: null });
      setSelectedDays([]);
      setScreen({ id: "", title: "" });
      setSelectedStores([]);

      fetchData(mediaId);
    }
  }, [open, mediaId]);

  const fetchData = (currentId) => {
    if (currentId > 0) {
      setLoading(true);
      Auth.fetch(`/media/media-id?id=${currentId}`)
        .then((res) => {
          let media = res.media[0];
          setFile(media.user_id + "/" + media.file);
          setImageTimeout(media.image_timeout);
          setMediaType(media.media_type);
          if (media?.scheduled_days) {
            const parsed = safeJsonParse(media.scheduled_days);
            setSelectedDays(parsed);
          }
          setSchedule({
            start: media?.start_time || null,
            end: media?.end_time || null,
          });
          if (res.ack) {
            Auth.fetch("/screen/screens").then((res1) => {
              if (res1.ack) {
                let screens1 = res1.screens;
                setScreens(screens1);
                let screen1 = screens1.filter((s) => s.id == media.screen_id);
                if (screen1.length) {
                  setScreen(screen1[0]);
                }

                Auth.fetch(
                  "/screen/screens-stores?screen_id=" + screen1[0]?.id
                ).then((res2) => {
                  setLoading(false);
                  if (res2.ack) {
                    const stores = res2.stores;
                    setStores(stores);
                    const selected_stores = [];

                    let storesArr = media.stores.split(",");
                    if (stores.length > 0) {
                      storesArr.forEach((st) => {
                        let st1 = stores.filter((s) => s.id == st);
                        if (st1.length) selected_stores.push(st1[0]);
                      });
                      setSelectedStores(selected_stores);
                    }
                  } else {
                    setStores([]);
                    setSelectedStores([]);
                  }
                });
              } else {
                setScreens([]);
                setLoading(false);
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    } else {
      setLoading(true);
      Auth.fetch("/screen/screens").then((res) => {
        setLoading(false);
        if (res.ack) {
          setScreens(res.screens);
        } else {
          setScreens([]);
        }
      });
    }
  };

  const formValidation = () => {
    let errorMessage = "";
    let isTimewrong = false;
    let isTimeoutMissing = false;
    putURLs.forEach((item) => {
      if (item.type === 1) {
        if (item.image_timeout < 5) {
          isTimewrong = true;
        }
        if (item.image_timeout === undefined || item.image_timeout < 0 || item.image_timeout === "") {
          isTimeoutMissing = true;
        }
      }
    });

    if (screen === null || screen?.id === "" || screen?.title === "") {
      errorMessage = "Please select screen";
    } else if (selectedStores.length === 0) {
      errorMessage = "Please select the store";
    } else if (id == 0 && putURLs.length === 0) {
      errorMessage = "Please upload the file";
    } else if (isTimewrong) {
      errorMessage = "Please enter valid timeout for media files (minimum 5s).";
    } else if (isTimeoutMissing) {
      errorMessage = "Please enter timeout for media files.";
    } else if (id > 0 && mediaType == 1 && imageTimeout < 5) {
      errorMessage = "Please enter valid timeout for media files (minimum 5s).";
    }

    return errorMessage;
  };

  const onChangeStore = (event, values) => {
    setSelectedStores(values);
  };

  const onChangeScreen = (event, values) => {
    setScreen(values);
    if (!values) {
      setStores([]);
      setSelectedStores([]);
      return;
    }
    setLoading(true);

    Auth.fetch("/screen/screens-stores?screen_id=" + values?.id).then((res) => {
      setLoading(false);
      if (res.ack) {
        const stores = res.stores;
        setStores(stores);
        const selected_stores = [];

        if (stores.length > 0) {
          stores.forEach((st) => {
            selected_stores.push(st);
          });
          setSelectedStores(selected_stores);
        }
      } else {
        setStores([]);
        setSelectedStores([]);
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let errorMessage = formValidation();
    if (errorMessage !== "") {
      setType("error");
      setLoadMessage(errorMessage);
      if (screen === null || screen?.id === "") {
        setScreenError("Required");
      } else {
        setScreenError("");
      }
      if (selectedStores.length === 0) {
        setSlectedStoreError("Required");
      } else {
        setSlectedStoreError("");
      }
      return;
    } else {
      setSlectedStoreError("");
      setScreenError("");
      setLoading(true);
      let images = [];
      putURLs.forEach((p) => {
        images.push({
          name: p.name,
          media_type: p.type,
          image_timeout: p.image_timeout,
        });
      });

      if (id > 0) {
        try {
          const res = await Auth.fetch("/media/media", {
            method: "PUT",
            body: JSON.stringify({
              image_timeout: imageTimeout,
              selected_stores: selectedStores,
              screen_id: screen?.id,
              id: id,
              scheduled_days: selectedDays,
              start_time: schedule.start,
              end_time: schedule.end,
            }),
          });

          if (res.ack) {
            setType("success");
            await Auth.fetch(`/media/media-sort-all-stores`, {
              method: "PUT",
              body: JSON.stringify({ screen_id: screen?.id }),
            });
            setTimeout(() => {
              setLoading(false);
              onSuccess && onSuccess();
              onClose();
            }, 1000);
          } else {
            setLoading(false);
            setType("error");
            setLoadMessage(res.message);
          }
        } catch (error) {
          setLoading(false);
          console.error("Error:", error);
        }
      } else {
        try {
          const res = await Auth.fetch("/media/save-media", {
            method: "POST",
            body: JSON.stringify({
              images: images,
              selected_stores: selectedStores,
              screen_id: screen?.id,
              scheduled_days: selectedDays,
              start_time: schedule.start,
              end_time: schedule.end,
            }),
          });

          for (let f of putURLs) {
            try {
              const data = await fetch(f.url, {
                method: "PUT",
                body: f.file,
                headers: {
                  "Content-Type": f.ContentType,
                },
              });

              if (data.status === 200) {
                console.log("File uploaded successfully", data);
              } else {
                console.error("Failed to upload file:", f.name);
              }
            } catch (error) {
              console.error("Error during file upload:", error);
              break;
            }
          }

          setLoading(false);
          setType("success");
          setLoadMessage("File(s) uploaded successfully");
          setTimeout(() => {
            onSuccess && onSuccess();
            onClose();
          }, 1000);

        } catch (error) {
          setLoading(false);
          console.error("Error:", error);
        }
      }
    }
  };

  const handleSubmitImage = (e) => {
    e.preventDefault();
    setLoading(true);
    let acceptedFiles = e.target.files;
    let uploadPromises = [];
    for (let idx = 0; idx < acceptedFiles.length; idx++) {
      var fileExt = acceptedFiles[idx].name.split(".").pop();

      let temp = Math.random().toString(36).slice(5);
      let file_name =
        acceptedFiles[idx].name
          .substring(0, 200)
          .split(".")
          .slice(0, -1)
          .join(".") +
        "---" +
        temp +
        "." +
        fileExt;
      let params = {
        bucket: config.aws_bucket,
        ContentType: acceptedFiles[idx].type,
        Key: file_name,
      };
      let promise = Auth.fetch(`/generate-put-url?${qs.stringify(params)}`, {
        headers: {
          "Content-Type": params.ContentType,
        },
      })
        .then((res) => {
          setPutURLs((prev) => [
            ...prev,
            {
              name: file_name,
              display_name:
                file_name.split("---")[0] + "." + file_name.split(".").pop(),
              image_timeout: screen?.image_timeout || 10,
              file: acceptedFiles[idx],
              url: res.putURL,
              type: acceptedFiles[idx].type.startsWith("image") ? 1 : 2,
              ContentType: acceptedFiles[idx].type,
            }
          ]);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
      uploadPromises.push(promise);
    }
    Promise.all(uploadPromises)
      .then((responses) => {
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      // Create a fake event object to pass to handleSubmitImage
      handleSubmitImage({
        preventDefault: () => { },
        target: { files: e.dataTransfer.files }
      });
    }
  };

  const confirmToDelete = (index) => {
    setPutURLs(putURLs.filter((i, ind) => ind !== index));
  };

  const deleteImage = (index) => {
    confirmationModal(() => {
      confirmToDelete(index);
    });
  };

  const showMessage = (msgType, msg) => {
    setInfo({ type: msgType, msg, _ts: Date.now() });
  };

  const handleScheduleChange = ({ key, value }) => {
    const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

    if (!timeRegex.test(value)) {
      showMessage(
        "error",
        "Invalid time format. Must be HH:mm (00:00 to 23:59)"
      );
      return;
    }

    const toMinutes = (timeStr) => {
      const [hours, minutes] = timeStr.split(":").map(Number);
      return hours * 60 + minutes;
    };

    const updated = { ...schedule, [key]: value };

    if (updated.start && updated.end) {
      const startMins = toMinutes(updated.start);
      const endMins = toMinutes(updated.end);

      if (endMins < startMins) {
        showMessage(
          "warning",
          "The selected time range crosses midnight and will extend into the next day."
        );
      }
    }

    setSchedule(updated);
  };

  const onChangeImageTimeout = (e, index) => {
    let putURLS1 = [...putURLs];
    putURLS1[index].image_timeout = e.target.value;
    setPutURLs(putURLS1);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: { borderRadius: "12px", overflow: "hidden" }
      }}
    >
      <DialogTitle sx={{ m: 0, p: 3, pb: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h5" fontWeight="600" color="textPrimary">
          {id > 0 ? "Edit Media Details" : "Add New Media"}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ color: (theme) => theme.palette.grey[500] }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ p: 3 }}>
        <LoaderSection state={loading} />
        {info?.msg && <Message key={info._ts} type={info.type} msg={info.msg} />}

        <Box component="form" noValidate autoComplete="off">
          <Grid container spacing={3}>
            {/* Screen Selection */}
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2" fontWeight="600" mb={1} color="textSecondary">
                Target Screen
              </Typography>
              <Autocomplete
                id="screen-select"
                size="medium"
                options={screens}
                getOptionLabel={(option) => option.title || ""}
                value={screen?.id ? screen : null}
                readOnly={id > 0}
                disabled={id > 0}
                onChange={onChangeScreen}
                sx={{
                  "& .MuiInputBase-root.Mui-disabled": {
                    backgroundColor: "rgba(0, 0, 0, 0.04)"
                  },
                  "& .MuiInputBase-input.Mui-disabled": {
                    WebkitTextFillColor: "rgba(0, 0, 0, 0.87)",
                    fontWeight: 500
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Select a screen..."
                    error={screenError !== ""}
                    helperText={screenError}
                  />
                )}
              />
            </Grid>

            {/* Stores Selection */}
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2" fontWeight="600" mb={1} color="textSecondary">
                Target Stores
              </Typography>
              <Autocomplete
                multiple
                id="stores-select"
                size="medium"
                options={stores}
                getOptionLabel={(option) => option.title || ""}
                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                filterSelectedOptions
                value={selectedStores}
                onChange={onChangeStore}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={slectedStoreError !== ""}
                    variant="outlined"
                    placeholder="Select stores..."
                    helperText={slectedStoreError}
                  />
                )}
              />
            </Grid>

            {/* Schedule Section */}
            <Grid item xs={12}>
              <Paper elevation={0} sx={{ p: 2, border: '1px solid', borderColor: 'divider', borderRadius: '8px' }}>
                <Typography variant="subtitle2" fontWeight="600" mb={2} color="textSecondary">
                  Schedule Settings
                </Typography>

                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Autocomplete
                      multiple
                      id="days-select"
                      size="medium"
                      options={daysOfWeek}
                      getOptionLabel={(option) => option}
                      isOptionEqualToValue={(option, value) => option === value}
                      filterSelectedOptions
                      value={selectedDays}
                      onChange={(e, val) => setSelectedDays(val)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder="Select days..."
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <TimePickerSelect
                      label="Start Time"
                      value={schedule.start}
                      onChange={(value) => handleScheduleChange({ key: "start", value })}
                    // interval={10}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <TimePickerSelect
                      label="End Time"
                      value={schedule.end}
                      onChange={(value) => handleScheduleChange({ key: "end", value })}
                      interval={10}
                    />
                  </Grid>
                </Grid>

                <Alert severity="info" icon={<ScheduleIcon />} sx={{ mt: 2, borderRadius: '8px' }}>
                  {generateScheduleSummary(selectedDays, schedule.start, schedule.end)}
                </Alert>
              </Paper>
            </Grid>

            {/* Media Upload and Preview Area */}
            <Grid item xs={12}>
              {id > 0 && file ? (
                <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: '12px', overflow: 'hidden' }}>
                  {/* Header Bar */}
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2.5, py: 2, bgcolor: '#f8f9fa', borderBottom: '1px solid', borderColor: 'divider' }}>
                    <Typography variant="subtitle2" fontWeight="700" color="textPrimary" sx={{ textTransform: 'uppercase', letterSpacing: '0.5px', fontSize: '0.75rem' }}>
                      Current Media Preview
                    </Typography>
                    {mediaType == 1 && (
                      <TextField
                        type="number"
                        label="Display Duration (sec)"
                        value={imageTimeout}
                        error={imageTimeout < 5}
                        helperText={imageTimeout < 5 ? "Minimum 5s required" : ""}
                        variant="outlined"
                        size="small"
                        sx={{
                          width: 200,
                          bgcolor: '#ffffff',
                          '& .MuiFormHelperText-root': { position: 'absolute', bottom: -20, ml: 0 }
                        }}
                        onChange={(e) => setImageTimeout(e.target.value)}
                      />
                    )}
                  </Box>

                  {/* Media Content Area */}
                  <Box sx={{ p: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', bgcolor: '#ffffff' }}>
                    {mediaType == 1 && (
                      <Box sx={{
                        position: 'relative',
                        borderRadius: '6px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                        border: '1px solid',
                        borderColor: 'divider',
                        backgroundColor: '#f5f5f5', // For transparent images
                        maxWidth: '450px'
                      }}>
                        <img
                          src={config.cloudfront_url + file}
                          style={{ display: 'block', maxWidth: "100%", maxHeight: "220px", objectFit: 'contain' }}
                          alt="media preview"
                        />
                      </Box>
                    )}
                    {mediaType == 2 && (
                      <Box sx={{
                        width: '100%',
                        maxWidth: '450px',
                        borderRadius: '6px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                        border: '1px solid',
                        borderColor: 'divider',
                        backgroundColor: '#000000'
                      }}>
                        <video width="100%" height="auto" controls autoPlay muted style={{ display: 'block', maxHeight: "220px" }}>
                          <source src={config.cloudfront_url + file} type="video/mp4" />
                        </video>
                      </Box>
                    )}
                  </Box>
                </Paper>
              ) : (
                <Box>
                  <Button
                    variant="outlined"
                    component="label"
                    fullWidth
                    onDragOver={handleDragOver}
                    onDragEnter={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    sx={{
                      border: '2px dashed',
                      borderColor: isDragging ? 'primary.main' : 'primary.light',
                      borderRadius: '12px',
                      p: 4,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: 1,
                      backgroundColor: isDragging ? 'rgba(25, 118, 210, 0.08)' : 'rgba(0,0,0,0.02)',
                      transition: 'all 0.2s ease-in-out',
                      transform: isDragging ? 'scale(1.01)' : 'scale(1)',
                      "&:hover": {
                        backgroundColor: 'rgba(25, 118, 210, 0.04)',
                        borderColor: 'primary.main'
                      }
                    }}
                  >
                    <CloudUploadIcon sx={{ fontSize: 48, color: isDragging ? 'primary.main' : 'primary.light' }} />
                    <Typography variant="h6" color="textPrimary">
                      {isDragging ? 'Drop Files Here' : 'Click or Drag Files Here'}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">Upload images or videos</Typography>
                    <input
                      type="file"
                      accept="image/*,video/*"
                      multiple
                      hidden
                      onChange={handleSubmitImage}
                    />
                  </Button>
                </Box>
              )}
            </Grid>

            {/* Uploaded Files List */}
            {putURLs.length > 0 && (
              <Grid item xs={12}>
                <Typography variant="subtitle2" fontWeight="600" mb={1} color="textSecondary">
                  Selected Files ({putURLs.length})
                </Typography>
                <Paper variant="outlined" sx={{ borderRadius: '8px', maxHeight: 300, overflow: 'auto' }}>
                  <List disablePadding>
                    {putURLs.map((row, index) => (
                      <React.Fragment key={index}>
                        <ListItem
                          sx={{ py: 1.5, display: 'flex', alignItems: 'center' }}
                          secondaryAction={
                            <IconButton edge="end" aria-label="delete" color="error" onClick={() => deleteImage(index)}>
                              <DeleteOutlineIcon />
                            </IconButton>
                          }
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 2, pr: 6 }}>
                            <Avatar variant="rounded" sx={{ width: 60, height: 45, bgcolor: 'transparent', flexShrink: 0 }}>
                              {row.type == 1 ? (
                                <img
                                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                  src={URL.createObjectURL(row.file)}
                                  alt={row.display_name}
                                />
                              ) : (
                                <PlayCircleOutlineIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
                              )}
                            </Avatar>

                            <Typography variant="body2" fontWeight="500" noWrap title={row.display_name} sx={{ flexGrow: 1, minWidth: 0 }}>
                              {row.display_name}
                            </Typography>

                            {row.type == 1 ? (
                              <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
                                <TextField
                                  type="number"
                                  size="small"
                                  label="Timeout (sec)"
                                  value={row.image_timeout}
                                  error={row.image_timeout < 5}
                                  onChange={(e) => onChangeImageTimeout(e, index)}
                                  sx={{ width: 110, '& .MuiInputBase-root': { height: 36 } }}
                                />
                                {row.image_timeout < 5 && (
                                  <Typography variant="caption" color="error" sx={{ ml: 1, position: 'absolute', mt: 5 }}>
                                    Min 5s
                                  </Typography>
                                )}
                              </Box>
                            ) : (
                              <Typography variant="caption" color="textSecondary" sx={{ flexShrink: 0 }}>
                                Video Media
                              </Typography>
                            )}
                          </Box>
                        </ListItem>
                        {index < putURLs.length - 1 && <Divider />}
                      </React.Fragment>
                    ))}
                  </List>
                </Paper>
              </Grid>
            )}
          </Grid>

          <Box mt={3}>
            <Message type={type} msg={loadMessage} />
          </Box>
        </Box>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ p: 2.5, px: 3, bgcolor: '#fafafa' }}>
        <Button onClick={onClose} variant="outlined" color="inherit" sx={{ borderRadius: '8px', px: 3 }}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={loading}
          sx={{
            borderRadius: '8px',
            px: 4,
            backgroundColor: appTheme.btnColor,
            "&:hover": {
              backgroundColor: appTheme.btnColor,
              filter: 'brightness(0.9)'
            },
          }}
        >
          {loading ? "Saving..." : "Save Media"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
